import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class UpdateOrder extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Update Order</h1>
				<p>This method updates properties of a specific order.</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> PUT </td>
							<td> {`/orders/{order_id}`} </td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<table>
					<tbody>
						<tr>
							<th>Parameter Name </th>
							<th>Value </th>
							<th>Optional </th>
							<th>Description </th>
						</tr>
						<tr>
							<td> order_id </td>
							<td> Integer </td>
							<td> N</td>
							<td> The ID of the order to update </td>
						</tr>
					</tbody>
				</table>
				<h4>Request body</h4>
				<p>In the request body, supply an <a href="?page=resource-representations-order">order resource</a>. The order resource object can include:</p>
				<ul>
					<li>cost.credit</li>
					<li>cost.insurance</li>
					<li>cost.etc1</li>
					<li>cost.etc2</li>
					<li>cost.shipping</li>
					<li>shipping.date_shipped</li>
					<li>shipping.tracking_no</li>
					<li>shipping.tracking_link</li>
					<li>shipping.method_id</li>
					<li>remarks</li>
					<li>is_filed</li>
				</ul>
				<p>Any attempt to update other fields that are not listed above would be ignored.</p>
				<p>Cost fields will only be updated if the order is in unpaid status. Otherwise they will be ignored.</p>
				<p>If sales tax are to be collected by BL, every change made to the costs will recalculate the sales tax.</p>
				<Highlight className="json">{`{
    "shipping": {
        "date_shipped": "Timestamp",
        "tracking_no": "String",
        "tracking_link": "String",
        "method_id": "Integer" 
    },
    "cost": {
        "shipping": "String",
        "insurance": "String",
        "credit": "String",
        "etc1": "String",
        "etc2": "String" 
    },
    "is_filed" : "Boolean",
    "remarks" : "String" 
}`}</Highlight>
				<h4>Response</h4>
				<p>If successful, this method returns an <a href="?page=resource-representations-order">order resource</a> as data in the response body.</p>
				<h4>Example</h4>
				<ul>
					<li>
						PUT /orders/1234
						<ul>
							<li>Updates order #1234</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}